import React, { useState } from "react";

const services = [
  {
    id: "junk",
    title: "Junk Removal",
    tag: "High-Growth Niche",
    desc: "We help junk removal companies dominate their local markets. From Google Ads and SEO to CRM automation and sales closing — we fill your trucks and grow your fleet.",
    img: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=700&q=80",
    labels: ["Local SEO", "Google Ads", "Lead Generation", "CRM Setup"],
  },
  {
    id: "cleaning",
    title: "Home Cleaning",
    tag: "Recurring Revenue",
    desc: "Cleaning businesses thrive on repeat clients. We build the systems — paid ads, appointment funnels, and retention campaigns — that turn one-time bookings into loyal monthly customers.",
    img: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=700&q=80",
    labels: ["Retention Funnels", "Paid Ads", "Booking Automation", "Brand Building"],
  },
  {
    id: "hvac",
    title: "HVAC",
    tag: "Seasonal Scaling",
    desc: "HVAC companies need consistent leads year-round, not just in peak season. We engineer campaigns that keep your technicians booked in summer and winter alike.",
    img: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=700&q=80",
    labels: ["Year-Round Leads", "Emergency Calls", "SEO Domination", "Sales Closing"],
  },
  {
    id: "plumbing",
    title: "Plumbing",
    tag: "Emergency Demand",
    desc: "Plumbing is urgent — your marketing should be too. We put your business at the top of search results when homeowners need help most, and convert those calls into booked jobs.",
    img: "https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=700&q=80",
    labels: ["Google LSA", "Call Tracking", "Review Generation", "Pipeline Growth"],
  },
  {
    id: "electrician",
    title: "Electrician",
    tag: "High-Ticket Jobs",
    desc: "We help electrical contractors land bigger, higher-value jobs — panel upgrades, EV charger installs, and commercial contracts — through targeted lead gen and professional branding.",
    img: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=700&q=80",
    labels: ["High-Ticket Leads", "Contractor Branding", "Outbound Outreach", "Web Development"],
  },
  {
    id: "landscaping",
    title: "Landscaping",
    tag: "Spring Rush Ready",
    desc: "Landscaping businesses have a short window to capture demand. We build pre-season campaigns, referral systems, and upsell funnels that maximize revenue every single year.",
    img: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=700&q=80",
    labels: ["Pre-Season Campaigns", "Referral Systems", "Upsell Funnels", "Local Ads"],
  },
  {
    id: "painting",
    title: "Painting",
    tag: "Brand Differentiation",
    desc: "In a crowded market, the best painters don't always win — the best-marketed ones do. We build your brand, generate qualified leads, and help you close more estimates.",
    img: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=700&q=80",
    labels: ["Estimate Conversion", "Brand Identity", "Lead Gen", "Social Proof"],
  },
  {
    id: "roofing",
    title: "Roofing",
    tag: "Storm Season Surge",
    desc: "Roofing companies that work with us scale fast. We deploy storm-response campaigns, door-to-door support systems, and digital funnels that generate high-ticket roofing contracts.",
    img: "https://images.unsplash.com/photo-1632207691143-643e2a9a9361?w=700&q=80",
    labels: ["Storm Campaigns", "High-Ticket Contracts", "D2D Support", "Digital Funnels"],
  },
];

const stats = [
  { value: "3×", label: "Average Revenue Growth" },
  { value: "50+", label: "Home Service Clients" },
  { value: "Canada", label: "Nationwide Coverage" },
  { value: "98%", label: "Client Retention Rate" },
];

export default function Industries() {
  const [hovered, setHovered] = useState(null);

  return (
    <section style={{ background: "#fff", color: "#111", fontFamily: '"Elza", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>

      {/* ══ HERO HEADER ══ */}
      <div style={{ background: "#fff", padding: "110px 24px 80px", textAlign: "center", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)", width: "900px", height: "500px", background: "radial-gradient(ellipse, rgba(123,25,188,0.07) 0%, transparent 65%)", pointerEvents: "none" }} />

        <div style={{ position: "relative", zIndex: 1 }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", fontSize: "11px", fontWeight: 700, letterSpacing: "3px", textTransform: "uppercase", color: "#7b19bc", background: "rgba(123,25,188,0.07)", padding: "7px 18px", borderRadius: "50px", border: "1px solid rgba(123,25,188,0.15)", marginBottom: "24px" }}>
            🍁 Scaling Home Service Businesses Across Canada
          </span>
          <h1 style={{ fontSize: "clamp(32px, 5vw, 62px)", fontWeight: 800, lineHeight: 1.1, margin: "0 auto 24px", maxWidth: "860px", letterSpacing: "-1.5px", color: "#0a0a0a" }}>
            We Grow the Companies That{" "}
            <span style={{ background: "linear-gradient(90deg, #7b19bc, #b06aff)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              Keep Canada Running
            </span>
          </h1>
          <p style={{ fontSize: "18px", color: "#666", maxWidth: "660px", margin: "0 auto 48px", lineHeight: 1.75 }}>
            Whether you run a junk removal crew or a plumbing company, we build the lead generation, sales systems, and marketing infrastructure that turns your business into a market leader.
          </p>

          {/* Stats bar */}
          <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "0", maxWidth: "800px", margin: "0 auto", border: "1px solid rgba(123,25,188,0.12)", borderRadius: "20px", overflow: "hidden", background: "#faf8ff" }}>
            {stats.map((s, i) => (
              <div key={s.label} style={{ flex: "1 1 160px", padding: "28px 20px", textAlign: "center", borderRight: i < stats.length - 1 ? "1px solid rgba(123,25,188,0.1)" : "none" }}>
                <div style={{ fontSize: "26px", fontWeight: 800, color: "#7b19bc", letterSpacing: "-0.5px" }}>{s.value}</div>
                <div style={{ fontSize: "12px", color: "#888", marginTop: "4px", letterSpacing: "0.3px" }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ══ SERVICES GRID ══ */}
      <div style={{ padding: "20px 24px 100px", maxWidth: "1300px", margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "24px" }}>
          {services.map((s) => (
            <div
              key={s.id}
              onMouseEnter={() => setHovered(s.id)}
              onMouseLeave={() => setHovered(null)}
              style={{
                borderRadius: "22px",
                overflow: "hidden",
                border: hovered === s.id ? "1px solid rgba(123,25,188,0.4)" : "1px solid rgba(0,0,0,0.08)",
                background: "#fff",
                boxShadow: hovered === s.id ? "0 24px 60px rgba(123,25,188,0.13)" : "0 4px 20px rgba(0,0,0,0.05)",
                transform: hovered === s.id ? "translateY(-8px)" : "none",
                transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)",
                cursor: "pointer",
              }}
            >
              {/* Image */}
              <div style={{ position: "relative", height: "210px", overflow: "hidden" }}>
                <img
                  src={s.img}
                  alt={s.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", transform: hovered === s.id ? "scale(1.05)" : "scale(1)", transition: "transform 0.5s ease" }}
                />
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to bottom, transparent 40%, rgba(0,0,0,0.6) 100%)" }} />
                <span style={{ position: "absolute", top: "14px", left: "14px", fontSize: "10px", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", padding: "5px 12px", borderRadius: "50px", background: "rgba(123,25,188,0.85)", color: "#fff", backdropFilter: "blur(8px)" }}>
                  {s.tag}
                </span>
                <h3 style={{ position: "absolute", bottom: "16px", left: "18px", margin: 0, fontSize: "22px", fontWeight: 800, color: "#fff", letterSpacing: "-0.3px" }}>{s.title}</h3>
              </div>

              {/* Body */}
              <div style={{ padding: "22px 22px 24px" }}>
                <p style={{ fontSize: "14px", color: "#555", lineHeight: 1.75, margin: "0 0 18px" }}>{s.desc}</p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "7px" }}>
                  {s.labels.map((l) => (
                    <span key={l} style={{ fontSize: "11px", fontWeight: 600, padding: "4px 11px", borderRadius: "50px", background: hovered === s.id ? "rgba(123,25,188,0.08)" : "#f5f3ff", color: "#7b19bc", border: "1px solid rgba(123,25,188,0.15)", letterSpacing: "0.3px", transition: "background 0.3s" }}>
                      {l}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ══ BOTTOM CTA BANNER ══ */}
      <div style={{ padding: "0 24px 100px", maxWidth: "1300px", margin: "0 auto" }}>
        <div style={{ borderRadius: "28px", background: "linear-gradient(135deg, #0d0d0d 0%, #1a0a2e 55%, #2d0a4e 100%)", padding: "70px 60px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "32px", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: "-100px", right: "10%", width: "400px", height: "400px", background: "radial-gradient(circle, rgba(176,106,255,0.22) 0%, transparent 65%)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", bottom: "-80px", left: "5%", width: "300px", height: "300px", background: "radial-gradient(circle, rgba(123,25,188,0.15) 0%, transparent 65%)", pointerEvents: "none" }} />

          <div style={{ position: "relative", zIndex: 1 }}>
            <span style={{ display: "inline-block", fontSize: "11px", fontWeight: 700, letterSpacing: "3px", textTransform: "uppercase", color: "#b06aff", marginBottom: "14px" }}>Ready to Scale?</span>
            <h2 style={{ fontSize: "clamp(24px, 3.5vw, 42px)", fontWeight: 800, color: "#fff", margin: "0 0 12px", letterSpacing: "-0.5px", maxWidth: "560px", lineHeight: 1.2 }}>
              Run a home service business in Canada?
            </h2>
            <p style={{ fontSize: "16px", color: "#9b8fb5", margin: 0, maxWidth: "480px", lineHeight: 1.7 }}>
              We'll build you a custom growth strategy — lead generation, sales systems, and marketing that fills your pipeline and scales your revenue.
            </p>
          </div>

          <div style={{ position: "relative", zIndex: 1, display: "flex", flexDirection: "column", gap: "14px", alignItems: "flex-start" }}>
            <a href="#contact" style={{ display: "inline-flex", alignItems: "center", gap: "10px", padding: "16px 36px", background: "linear-gradient(135deg, #7b19bc, #b06aff)", color: "#fff", fontWeight: 700, fontSize: "15px", textDecoration: "none", borderRadius: "12px", letterSpacing: "0.3px", whiteSpace: "nowrap" }}>
              Get a Free Strategy Call →
            </a>
            <a href="#services" style={{ fontSize: "13px", color: "rgba(255,255,255,0.45)", textDecoration: "none", paddingLeft: "4px", letterSpacing: "0.3px" }}>
              See how we work ↓
            </a>
          </div>
        </div>
      </div>

    </section>
  );
}
